import { Account } from '../../schemas';
import RadioButton from '@rio-cloud/rio-uikit/RadioButton';
import { FormattedMessage } from 'react-intl';

const getSelectedClass = (isSelected: boolean) =>
    isSelected ? 'border-color-highlight bg-highlight-decent z-index-1' : '';

export const AccountsList = ({
    selectedAccountId,
    accounts,
    onSelectionChange,
}: {
    selectedAccountId: string | undefined;
    accounts: Account[];
    onSelectionChange: (accId: string) => void;
}) => {
    const firstClassNames = 'rounded-top-left rounded-top-right';
    const intermediateClassNames = 'margin-top--1';
    const lastClassNames = 'margin-top--1 rounded-bottom-left rounded-bottom-right';

    const showOverflow = accounts.length > 4;

    return (
        <>
            <div
                style={{ maxHeight: '175px' }} // there is no predefined class for 175
                className={'bg-white' + (showOverflow ? ' overflow-y-scroll' : '')}
            >
                {accounts.map((account, index) => {
                    let calculatedClassName;

                    if (index === 0) {
                        calculatedClassName = firstClassNames;
                    } else if (index === accounts.length - 1) {
                        calculatedClassName = lastClassNames;
                    } else {
                        calculatedClassName = intermediateClassNames;
                    }
                    const isLocked = account.lifecycle_state == 'locked';

                    return (
                        <RadioButton
                            key={account.id}
                            name="stackedRadioBoxes"
                            custom
                            className={`padding-10 ${calculatedClassName} border ${getSelectedClass(
                                selectedAccountId === account.id
                            )}`}
                            onChange={() => onSelectionChange(account.id)}
                            checked={selectedAccountId === account.id}
                            disabled={isLocked}
                        >
                            <div className="radio-text-wrapper display-flex">
                                <span className="radio-text" />
                                <div className="margin-left-5 margin-right-5 accountNameBox">
                                    <div className={isLocked ? 'text-color-dark' : 'text-medium'}>
                                        {isLocked && <span className="rioglyph rioglyph-lock margin-right-5" />}
                                        <span className="margin-right-10">{account.name}</span>
                                        {account.active && (
                                            <span className="text-color-dark">
                                                <FormattedMessage
                                                    id={'intl-msg:settingsDialog.tab.accounts.text.current'}
                                                />
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </RadioButton>
                    );
                })}
            </div>
        </>
    );
};
